import React from "react";
import TelegramChannel from "../../elements/telegramLink/TelegramChannel";
import { useTranslation } from "react-i18next";

import { StyledDocumentWrapper } from "../../styles/styledTextDocument";
import { Alert } from "@material-ui/lab";
import { StyledHomeWarning } from "../styledHome";

const IntegrationSteps = () => {
  const { t } = useTranslation("homePage");

  return (
    <StyledDocumentWrapper>
      <TelegramChannel t={t} />
      <StyledHomeWarning>
        <Alert severity="warning">
          <p>
            {t("unavailabilityServices.title")}
          </p>
          <p>
            {t("unavailabilityServices.text")}
          </p>
          <ul>
            <li>
              Garantex;
            </li>
            <li>
              Сapitalist.net;
            </li>
            <li>
              Tornado Cash;
            </li>
            <li>
              Hydra;
            </li>
            <li>
              Blender.io;
            </li>
            <li>
              Lazarus Group;
            </li>
            <li>
              Genesis Market;
            </li>
            <li>
              ChipMixer;
            </li>
            <li>
              Shinbad.io;
            </li>
            <li>
              CommEx.
            </li>
          </ul>
        </Alert>
      </StyledHomeWarning>
      {/*<StyledDocumentTitle as="h2" size="18">
        Шаги для планирования интеграции API
      </StyledDocumentTitle>
      <StyledDocumentText size="16">
        Перед началом <NavLink to="/" className="default-link">интеграции API</NavLink> изучите следующие шаги, которые
        помогут вам определить затраты и время на
        разработку. Эти этапы учитывают бизнес-процессы и процессы технического планирования.
      </StyledDocumentText>
      <StyledDocumentSubTitle as="h3" size="16">
        Планирование интеграции API:
      </StyledDocumentSubTitle>
      <StyledDocumentList size="16">
        <li>
          Создать план и задокументировать бизнес-процессы и проблемные вопросы;
        </li>
        <li>
          Охарактеризовать потребности бизнеса и задокументировать функции ПО, необходимые для решения проблемных
          вопросов;
        </li>
        <li>
          Определить необходимые API, которые будут соответствовать потребностям бизнеса;
        </li>
        <li>
          Запросить у сотрудников ИТ-подразделения предварительную оценку того, что будет наиболее эффективно:
          разработать или купить технологию;
        </li>
        <li>
          Определить, какой уровень профессионализма разработчика требуется для программирования XML или веб-сервиса;
        </li>
        <li>
          Оценить затраты и время, требуемые для интеграции API (разработки) или приобретения ПО с интегрированным API
          (покупки).
        </li>
      </StyledDocumentList>
      <StyledDocumentSubTitle as="h3" size="16">
        Оценка должна включать:
      </StyledDocumentSubTitle>
      <StyledDocumentList as="ol" size="16">
        <li>
          Количество и тип затронутых платформ и систем;
        </li>
        <li>
          Влияние высокого уровня на логику интерфейсов и внутренней обработки каждой системы;
        </li>
        <li>
          Количество <NavLink to="/" className="default-link">интегрируемых API</NavLink>;
        </li>
        <li>
          Провести анализ рентабельности, включая поддержку;
        </li>
        <li>
          Принять решение относительно разработки или приобретения, основываясь на расчетах затрат и времени, требуемых
          для интеграции API.
        </li>
      </StyledDocumentList>
      <StyledDocumentText size="16">
        <b>Перед началом интеграции API</b> изучите следующие шаги, которые помогут вам определить затраты и время на
        разработку. Эти этапы учитывают бизнес-процессы и процессы.
      </StyledDocumentText>*/}
    </StyledDocumentWrapper>
  );
};

export default IntegrationSteps;

